import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Alert } from '@classes/alert/alert';
import { environment } from '@environments/environment';
import { LicenseService } from '@services/anpr/license.service';
import { mediaService } from '@services/media/media.service';
import { NotificationService } from '@services/notifications/notification.service';
import { UserService } from '@services/user/user.service';
import * as moment from 'moment';

export interface DialogData {
  alert: Alert;
  index: number;
  length: number;
  safeUrl: any;
  mediaId: string;
}

@Component({
  selector: 'app-video-timeline',
  templateUrl: './video-timeline.component.html',
  styleUrls: ['./video-timeline.component.scss'],
})
export class VideoTimelineComponent implements OnInit {
  @ViewChild('videoElement') public videoElement: ElementRef;
  // @Input('snapshotName') public snapshotName: string;
  @Input('downloadImageType') public userImageType: string;
  safeUrl: any;
  loading: boolean = true;
  url: any;
  media: string;
  alert: string;
  dateSplit = this.data.alert.externalId
    .replace(/\_/g, '-')
    .replace(/\.jpg/g, '')
    .split('-');
  newDate = `${this.dateSplit[0]}/${this.dateSplit[1]}/${this.dateSplit[2]} ${this.dateSplit[3]}:${this.dateSplit[4]}`;
  dateParseZone = moment(this.newDate)
    .parseZone()
    .utc()
    .local()
    .format('DD/MM/YYYY/HH:mm');
  dateUnderFive = moment(this.newDate)
    .parseZone()
    .utc()
    .add(-5, 'minutes')
    .local()
    .format('DD/MM/YYYY/HH:mm');
  public snapshotImageType: string = 'JPG';
  public imageTypes = [
    'JPG',
    'PNG',
    'BMP',
    'TIFF',
    'GIF',
    'PPM',
    'PGM',
    'PBM',
    'PNM',
    'WebP',
    'HEIF',
    'BPG',
    'ECW',
    'FITS',
    'FLIP',
    'PAM',
    'CD5',
    'CPT',
    'PSD',
    'PSP',
    'XCF',
    'PDN',
  ];
  isLoading: boolean;
  canUseAnpr: boolean;
  // public snapshotName: string = this.dateUnderFive;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private sanitizer: DomSanitizer,
    private mediaService: mediaService,
    private notificationService: NotificationService,
    private userService: UserService,
    private licenseService: LicenseService,
    private router: Router,
    public dialogRef: MatDialogRef<VideoTimelineComponent>,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.isLoading = false;
    this.data.mediaId;
    this.data.alert;
    this.data;
    this.checkAnpr();
    this.fetch(this.data.mediaId);
  }

  public takeSnapshot() {
    const canvasElement = <HTMLCanvasElement>document.createElement('CANVAS');
    const video = this.videoElement.nativeElement;
    const context = canvasElement.getContext('2d');
    let w: number, h: number, ratio: number;
    ratio = video.videoWidth / video.videoHeight;
    w = video.videoWidth - 100;
    h = w / ratio;
    canvasElement.width = w;
    canvasElement.height = h;
    context.fillRect(0, 0, w, h);
    context.drawImage(video, 0, 0, w, h);
    const link = document.createElement('a');
    // this.snapshotName = this.snapshotName !== '';
    this.userImageType =
      this.imageTypes.indexOf(this.userImageType) >= 0
        ? this.userImageType
        : 'PNG';
    link.setAttribute(
      'download',
      this.dateUnderFive + '.' + this.userImageType
    );
    const dataURL = canvasElement.toDataURL();
    link.href = dataURL;
    document.body.appendChild(link);
    link.click();
  }

  getMediaById(): void {
    this.data.alert?.medias?.forEach((t) => {
      this.fetch(t.id);
    });
  }

  private fetch(id) {
    // ------ ATTENTION : à décommenter au moment du déploiement -----------
    this.url = `${environment.apiUrl}/medias/${id}/file`;
    // this.url = 'assets/videos/anpr_test.mp4';
  }

  public checkAnpr(): void {
    let client = this.userService.clientSelected;
    this.licenseService.getClientLicense(client).subscribe((res) => {
      if (typeof res !== 'undefined' && res.status.name == 'Active') {
        this.canUseAnpr = true;
      } else {
        this.canUseAnpr = false;
      }
    });
  }

  public onClickAnpr() {
    this.isLoading = true;
    const canvasElement = <HTMLCanvasElement>document.createElement('CANVAS');
    const video = this.videoElement.nativeElement;
    const context = canvasElement.getContext('2d');
    let w: number, h: number, ratio: number;
    ratio = video.videoWidth / video.videoHeight;
    w = video.videoWidth;
    h = w / ratio;
    canvasElement.width = w;
    canvasElement.height = h;
    context.fillRect(0, 0, w, h);
    context.drawImage(video, 0, 0, w, h);
    var imageBase64 = canvasElement.toDataURL();
    var file = this.licenseService.dataUrlToFile(imageBase64, 'image_anpr');
    this.licenseService.useAnpr(file).subscribe((res) => {
      this.router.navigate(['/smartwaste/ANPR']);
      this.dialog.closeAll();
    });
  }
}
